module.exports = __webpack_public_path__ + "static/media/edanra.e2e62dc5.png";